export default __webpack_public_path__ + "static/media/cherryl.8afd9552.jpeg";